import useOrganizationStore from "@lib/store/organization";
import type { Router } from "vue-router";
import type { TOrganization } from "@/interfaces/app";
import { useTranslationOverrides } from "@/composables/translation-overrides";

export default defineNuxtPlugin((app) => {
  const { loadTranslationOverrides } = useTranslationOverrides();
  const getCurrentOrganization = (): TOrganization | null => {
    const $route = (app.$router as Router).currentRoute.value;
    const { organizations, organization } = useOrganizationStore();
    if (organization) {
      return organization;
    }
    if (!organizations || organizations.length < 1) {
      return null;
    }
    const routeOrgId = $route.params.org_id;
    let _organization = organizations.find((org) => org.public_id === routeOrgId);
    if (routeOrgId && _organization) {
      setCurrentOrganization(_organization);
      return _organization;
    }

    const orgId = localStorage.getItem("advisor/lastOrgId");
    _organization = organizations.find((org) => org.public_id === orgId);
    if (orgId && _organization) {
      setCurrentOrganization(_organization);
      return _organization;
    }
    setCurrentOrganization(organizations[0] ?? null);
    return organizations[0] ?? null;
  };

  const setCurrentOrganization = (organization: TOrganization | null) => {
    if (!organization) {
      loadTranslationOverrides(null);
      localStorage.removeItem("advisor/lastOrgId");
      return;
    }
    const orgId = organization.public_id;
    const { organizations, setSelectedOrganization } = useOrganizationStore();
    const isOrganizationInList = organizations.find((org) => org.public_id === orgId);
    if (isOrganizationInList) {
      localStorage.setItem("advisor/lastOrgId", orgId ?? "");
      setSelectedOrganization(organization);
      loadTranslationOverrides(organization.translations_override);
    }
  };

  return {
    provide: {
      organization: {
        getCurrent: getCurrentOrganization,
        setCurrent: setCurrentOrganization,
      },
    },
  };
});
